<template>
    <table class="table" id="counts-table">
        <thead>
        <tr class="tr">
            <th class="td">{{$t(`table.date`)}}</th>
            <th class="td" v-if="hasShopColumn">{{$t('table.shop')}}</th>
            <th class="td" v-for="(n,index) in data.summary.countsData"><span v-if="isNaN(index)">{{$t(`general.days.${index}`)}}</span><span
                    v-else>{{index}}</span></th>
            <th class="td">{{$t(`table.sum`)}}</th>
            <th class="td">{{$t(`table.minTemp`)}}</th>
            <th class="td">{{$t(`table.maxTemp`)}}</th>
            <th class="td">{{$t(`table.weather`)}}</th>
        </tr>
        </thead>
        <tbody>
        <tr class="tr" v-for="(row,index) in data.rows">
            <td class="td" v-if="translatable">{{$t(`general.months.${index.split(' ')[0]}`)}}

            </td>
            <td class="td" v-else>{{index.split(' ')[0]}}</td>
            <td class="td" v-if="hasShopColumn">{{index.replace(index.split(' ')[0],'')}}</td>
            <td class="td" v-for="cData in row.countsData">{{cData}}</td>
            <td class="td">{{row.rowSummary}}</td>
            <td class="td">{{row.minTemp}} <span :v-html="degree"></span></td>
            <td class="td">{{row.maxTemp}} <span :v-html="'&#8451;'"></span></td>
            <td class="td weather-container" v-if="row.weatherDescription"><img :src="getImgUrl(row.weatherDescription)"
                                                                                :title="getTitle(row.weatherDescription)">
            </td>
            <td class="td" v-else></td>
        </tr>
        <tr class="tr">
            <td class="td" v-if="hasShopColumn"></td>
            <td class="td">{{$t('reports.summary')}}</td>
            <td class="td" v-for="cData in data.summary.countsData">{{cData}}</td>
            <td class="td">{{data.summary.rowSummary}}</td>
            <td class="td">{{data.summary.minTemp}} <span :v-html="degree"></span></td>
            <td class="td">{{data.summary.maxTemp}} <span :v-html="degree"></span></td>
            <td class="td">{{data.summary.weather}}</td>
        </tr>
        </tbody>
    </table>

</template>

<script>
export default {
  name: 'CountsTable',
  data() {
    return {
      degree: '&#8451;',
    };
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
    translatable: {
      type: Boolean,
      required: true,
      default: false,
    },
    mode: {
      type: String,
      required: false,
      default: 'no',
    },
  },
  computed: {
    hasShopColumn() {
      const specimen = Object.keys(this.data.rows)[0];
      const test = specimen.split(' ');
      if (test.length > 1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    getTitle(description) {
      let desc = '01';
      if (description !== undefined) {
        desc = description.match(/^[0-9][0-9]/);
        if (desc === null) {
          desc = '01';
        }
      }
      return this.$t(`weather.${desc}`);
    },
    getImgUrl(pic) {
      let file = '01';
      if (pic !== undefined) {
        file = pic.match(/^[0-9][0-9]/);
        if (file === null) {
          file = '01';
        }
      }

      return require(`@/assets/images/weather/${file}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
    table {
        width: 95%;
        margin: 0 auto;
    }

    .table {
        box-shadow: none;
        text-align: center;
    }

    .tr {

        .td {
            padding: 13px;
        }

        &:first-child {
            .td {
                border: none;
                border-bottom: 1px solid $border-blue;
            }
        }

        &:not(:last-child) {
            .td {
                vertical-align: middle;
                // border: 1px solid $border-gray;
                border-bottom: 1px solid $border-gray;

                &:first-child {
                    border-left: none;
                    border-right: 1px solid $border-gray;
                }

                &:nth-last-child(-n+4) {
                    border-right: none;
                    border-left: 1px solid $border-gray;

                }
            }
        }

        &:last-child {
            font-weight: bold;

            .td {
                padding: 13px 0;
                border-bottom: 1px solid $border-gray;

                &:first-child, &:last-child {
                    border-right: 1px solid $border-gray;

                }
            }
        }
    }

    .weather-container {
        display: table-cell;
        vertical-align: middle;

        img {
            width: 45px;
        }
    }
</style>
